(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sppr-wall-graphics"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init() {
    const root = document.getElementById('wg-root');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('#wg-config').textContent);
    if (!config.preview) root.querySelector('.wg-preview')?.remove();
    const s = config.strings;
    const form = root.querySelector('#wg-form');
    const $ = id => root.querySelector('#wg-' + id);
    const factors = {feet: 1, inches: 1 / 12, centimeters: 1 / 30.48, meters: 1 / 0.3048};
    const metro = new Set(['San Juan','Bayamón','Carolina','Guaynabo','Toa Baja','Toa Alta','Trujillo Alto','Canóvanas','Cataño']);
    const islands = new Set(['Vieques','Culebra']);
    const uploads = {photo: new Map(), design: new Map()};
    let serial = 0;
    const known = () => form.querySelector('input[name="contact[Measurements known]"]:checked')?.value;
    const fee = () => !known() || known() === 'yes' || !$('municipality').value || islands.has($('municipality').value) ? null : metro.has($('municipality').value) ? 200 : 350;
    const money = n => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(n);
    function error(message) { $('error').textContent = message; $('error').hidden = !message; }
    function field(label, element) { const wrap = document.createElement('div'); const l = document.createElement('label'); l.htmlFor = element.id; l.textContent = label; wrap.append(l,element); return wrap; }
    function areas() {
      return [...$('areas').children].map((row, index) => {
        const width = Number(row.querySelector('[data-width]').value);
        const height = Number(row.querySelector('[data-height]').value);
        const unit = row.querySelector('[data-unit]').value;
        const area = width * height * factors[unit] ** 2;
        return {label: row.querySelector('[data-name]').value || s.area + ' ' + (index + 1), width, height, unit, area: Number.isFinite(area) ? area : 0};
      });
    }
    function calculate() {
      const values = areas();
      values.forEach((a,index) => { $('areas').children[index].querySelector('output').textContent = a.area.toFixed(2) + ' ' + s.sqft; });
      const total = values.reduce((sum,a) => sum + a.area,0);
      $('total').textContent = total.toFixed(2);
      summary(); syncBody();
    }
    function summary() {
      const amount = fee();
      $('summary').textContent = known() === 'yes' ? s.total + ': ' + $('total').textContent + ' ' + s.sqft + '. ' + s.no_payment : amount ? s.survey + ': ' + money(amount) + ' — ' + $('municipality').value : islands.has($('municipality').value) && known() === 'no' ? s.custom : s.select_first;
    }
    function addArea() {
      if ($('areas').children.length >= 30) { error(s.area_limit); return; }
      const row = document.createElement('div'); row.className = 'wg-area'; row.dataset.area = String(++serial);
      const heading = document.createElement('h3'); heading.textContent = s.area + ' ' + ($('areas').children.length + 1); row.append(heading);
      const name = document.createElement('input'); name.id = 'wg-area-name-' + serial; name.dataset.name = ''; name.maxLength = 100;
      row.append(field(s.area_name,name));
      const grid = document.createElement('div'); grid.className = 'wg-dimensions';
      ['width','height'].forEach(key => { const input = document.createElement('input'); input.type = 'number'; input.min = '0.001'; input.step = 'any'; input.required = true; input.inputMode = 'decimal'; input.id = 'wg-' + key + '-' + serial; input.dataset[key] = ''; grid.append(field(s[key] + ' *',input)); });
      const unit = document.createElement('select'); unit.id = 'wg-unit-' + serial; unit.dataset.unit = ''; unit.dataset.previous = 'feet';
      Object.keys(factors).forEach(key => { const option = document.createElement('option'); option.value = key; option.textContent = s[key]; unit.append(option); });
      unit.addEventListener('change', () => { ['width','height'].forEach(key => { const input = row.querySelector('[data-' + key + ']'); if (input.value && Number(input.value) > 0) input.value = String(Number((Number(input.value) * factors[unit.dataset.previous] / factors[unit.value]).toFixed(6))); }); unit.dataset.previous = unit.value; calculate(); });
      grid.append(field(s.unit,unit)); row.append(grid);
      const footer = document.createElement('div'); footer.className = 'wg-area-footer';
      const output = document.createElement('output'); output.textContent = '0.00 ' + s.sqft; output.setAttribute('aria-live','polite');
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'wg-remove'; remove.textContent = s.remove;
      remove.addEventListener('click', () => { row.remove(); renumber(); calculate(); $('review').hidden = true; });
      footer.append(output,remove); row.append(footer); $('areas').append(row); renumber(); calculate();
      if ($('areas').children.length > 1) name.focus();
    }
    function renumber() {
      [...$('areas').children].forEach((row,index) => { row.querySelector('h3').textContent = s.area + ' ' + (index + 1); ['name','width','height','unit'].forEach(key => { row.querySelector('[data-' + key + ']').name = 'contact[Area ' + (index + 1) + ' ' + key + ']'; }); const remove = row.querySelector('button'); remove.disabled = $('areas').children.length === 1; remove.setAttribute('aria-label',s.remove + ' ' + (index + 1)); });
    }
    function branch() {
      const value = known();
      $('known').hidden = value !== 'yes'; $('known').disabled = value !== 'yes';
      $('unknown').hidden = value !== 'no'; $('unknown').disabled = value !== 'no';
      $('details').hidden = !value; $('details').disabled = !value;
      const other = value === 'yes' && $('surface').value === 'other';
      $('other-wrap').hidden = !other; $('other').disabled = !other; $('other').required = other;
      const amount = fee(); const custom = value === 'no' && islands.has($('municipality').value);
      $('fee').hidden = !amount && !custom;
      $('fee-amount').textContent = amount ? money(amount) + ' USD' : s.custom;
      $('fee-help').textContent = amount ? (amount === 200 ? s.metro : s.mainland) + '. ' + s.amount_help : s.custom_help;
      $('policy').hidden = !amount; $('ack').required = !!amount; $('ack').disabled = !amount;
      $('submit').textContent = amount ? config.preview ? s.preview_pay : s.pay : config.preview ? s.preview_quote : s.quote;
      if (config.quoteTest && value === 'yes') $('submit').textContent = s.test_quote;
      $('review').hidden = true; error(''); syncUploadInputs(); summary(); syncBody();
    }
    function filesValid(input,kind) {
      if (input.disabled) { input.setCustomValidity(''); return true; }
      const files = [...input.files];
      const re = kind === 'photo' ? /\.(jpe?g|png|webp|hei[cf])$/i : /\.(pdf|ai|eps|svg|png|jpe?g)$/i;
      const valid = files.length <= (kind === 'photo' ? 10 : 5) && files.every(f => f.size > 0 && f.size <= 10 * 1024 * 1024 && re.test(f.name));
      input.setCustomValidity(valid ? '' : s.files_error); return valid;
    }
    function describe() {
      const result = [s.title, s.question + ' ' + s[known()]];
      if (known() === 'yes') {
        areas().forEach(a => result.push(a.label + ': ' + a.width + ' × ' + a.height + ' ' + s[a.unit] + ' = ' + a.area.toFixed(2) + ' ' + s.sqft));
        result.push(s.total + ': ' + $('total').textContent + ' ' + s.sqft);
        ['surface','placement','condition','installation'].forEach(key => result.push(s[key] + ' ' + s[$(key).value]));
        if ($('surface').value === 'other') result.push($('other').value);
        if (uploads.photo.size) result.push(s.photos + ': ' + $('photo-links').value);
        else if (config.preview) result.push(s.photos + ': ' + [...$('photos').files].map(f=>f.name).join(', '));
      } else {
        result.push(s.project_location + ':');
        result.push(s.project_address + ': ' + $('project-address').value.trim());
        if ($('project-address2').value.trim()) result.push(s.project_address2 + ': ' + $('project-address2').value.trim());
        result.push(s.municipality + ': ' + $('municipality').value);
        result.push(s.project_zip + ': ' + $('project-zip').value.trim());
        if ($('project-access').value.trim()) result.push(s.project_access + ': ' + $('project-access').value.trim());
        result.push(fee() ? s.due + ': ' + money(fee()) + ' USD' : s.custom);
        if (fee()) result.push(s.notice);
      }
      result.push(s.name + ': ' + $('name').value, s.email + ': ' + $('email').value);
      if ($('phone').value) result.push(s.phone + ': ' + $('phone').value);
      if ($('notes').value) result.push($('notes').value);
      if (uploads.design.size) result.push(s.design + ': ' + $('design-links').value);
      else if (config.preview && $('design').files.length) result.push(s.design + ': ' + [...$('design').files].map(f=>f.name).join(', '));
      return result;
    }
    function syncBody() {
      $('body').value = known() ? describe().join('\n') : '';
    }
    function uploadMounted(kind) {
      return !!root.querySelector('.wg-' + kind + '-upload').querySelector('.cl-upload--wrapper, .cl-upload--area');
    }
    function syncUploadInputs() {
      ['photo','design'].forEach(kind => {
        const input = $(kind === 'photo' ? 'photos' : 'design');
        const mounted = uploadMounted(kind);
        input.hidden = mounted;
        input.disabled = mounted || (kind === 'photo' ? known() !== 'yes' : !known());
        input.required = kind === 'photo' && known() === 'yes' && !mounted && uploads.photo.size === 0;
        if (mounted) { input.value = ''; input.setCustomValidity(''); }
      });
      $('photo-links').disabled = known() !== 'yes';
    }
    ['photo','design'].forEach(kind => {
      const container = root.querySelector('.wg-' + kind + '-upload');
      function syncLinks() {
        $(kind + '-links').value = [...uploads[kind].values()].join('\n');
        $('review').hidden = true;
        syncUploadInputs(); syncBody();
      }
      container.addEventListener('upload:added',event => {
        const file = event.detail;
        if (!file?.url || file.meta?.variant === 'thumbnail') return;
        try { if (new URL(file.url).protocol !== 'https:') return; } catch { return; }
        uploads[kind].set(file.url,file.url);
        syncLinks();
      });
      container.addEventListener('upload:removed',event => {
        uploads[kind].delete(event.detail?.url);
        syncLinks();
      });
      const observer = new MutationObserver(() => {
        if (!root.isConnected) { observer.disconnect(); return; }
        syncUploadInputs();
      });
      observer.observe(container,{childList:true,subtree:true});
    });
    $('photos').addEventListener('change',() => filesValid($('photos'),'photo'));
    $('design').addEventListener('change',() => filesValid($('design'),'design'));
    $('add').addEventListener('click',addArea);
    $('municipality').addEventListener('change',() => { $('ack').checked = false; branch(); });
    $('surface').addEventListener('change',branch);
    form.querySelectorAll('input[name="contact[Measurements known]"]').forEach(input => input.addEventListener('change',branch));
    form.addEventListener('input',() => { $('review').hidden = true; error(''); calculate(); });
    form.addEventListener('change',() => { $('review').hidden = true; syncBody(); });
    async function processRequest() {
      if ($('submit').disabled) return;
      if (!known()) { error(s.select_first); return; }
      const previewRequest = config.preview && !(config.quoteTest && known() === 'yes');
      syncUploadInputs();
      if (known() === 'yes' && !uploads.photo.size && (uploadMounted('photo') || !previewRequest || !$('photos').files.length)) { error(s.photo_required); return; }
      if (known() === 'yes' && !filesValid($('photos'),'photo')) { $('photos').reportValidity(); return; }
      if (!filesValid($('design'),'design')) { $('design').reportValidity(); return; }
      if (!form.reportValidity()) return;
      if (known() === 'yes' && !previewRequest && !uploads.photo.size) { error(s.upload_pending); return; }
      if (!previewRequest && $('design').files.length && !uploads.design.size) { error(s.upload_pending); return; }
      calculate();
      const description = describe();
      $('body').value = description.join('\n');
      if (previewRequest) {
        $('review-body').replaceChildren();
        description.forEach(line => { const p = document.createElement('p'); p.textContent = line; $('review-body').append(p); });
        $('review-note').textContent = fee() ? s.not_charged : s.not_sent;
        $('review').hidden = false; $('review').focus(); return;
      }
      $('body').value = description.join('\n');
      if (!fee()) {
        if (typeof window.Shopify?.captcha?.protect !== 'function') { error(s.captcha_error); return; }
        const fail = () => { error(s.captcha_error); $('submit').disabled = false; };
        $('submit').disabled = true;
        try {
          window.Shopify.captcha.protect(form, () => {
            try { form.submit(); } catch { fail(); }
          });
        } catch { fail(); }
        return;
      }
      const props = {Project:'Wall Graphics', 'Measurements known':'No', Municipality:$('municipality').value, 'Project Address':$('project-address').value.trim(), 'Project Address Line 2':$('project-address2').value.trim(), 'Project Municipality':$('municipality').value, 'Project ZIP Code':$('project-zip').value.trim(), 'Project Access Notes':$('project-access').value.trim(), 'Survey policy':s.notice, 'Contact name':$('name').value, 'Contact email':$('email').value, Phone:$('phone').value, Details:$('notes').value, Design:$('design-links').value};
      $('submit').disabled = true;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:fee() === 200 ? config.metroVariant : config.islandVariant,quantity:1,properties:props}]})});
        if (!response.ok) throw new Error('cart');
        window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      } catch { error(s.checkout_error); $('submit').disabled = false; }
    }
    root.addEventListener('click', event => {
      if (!event.target.closest('#wg-submit')) return;
      event.preventDefault(); event.stopImmediatePropagation();
      processRequest();
    }, true);
    root.addEventListener('submit', event => {
      if (event.target !== form) return;
      event.preventDefault(); event.stopImmediatePropagation();
      processRequest();
    }, true);
    form.addEventListener('keydown', event => {
      if (event.key !== 'Enter' || event.isComposing || event.target.tagName !== 'INPUT' || ['file','checkbox','radio'].includes(event.target.type)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      processRequest();
    }, true);
    window.addEventListener('pageshow', () => { $('submit').disabled = false; });
    addArea(); branch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();
})();
